// extracted by mini-css-extract-plugin
export default {"container":"ZJ-z","dimension":"_J-z","dimensionLabels":"aK-z"};